/**
 * Lightweight in-memory token store — no Zustand dependency.
 * The auth Zustand store syncs into this on login/logout/refresh.
 * The API client reads from this — no circular deps.
 */

let _accessToken: string | null = null;
let _onAuthExpired: ((reason?: 'security') => void) | null = null;

export const tokenStore = {
  /** Register a callback invoked when auth tokens expire (called by auth-store) */
  onAuthExpired: (cb: (reason?: 'security') => void): void => {
    _onAuthExpired = cb;
  },
  /** Notify that auth has expired — triggers logout via the registered callback */
  notifyAuthExpired: (reason?: 'security'): void => {
    _onAuthExpired?.(reason);
  },
  getAccessToken: (): string | null => _accessToken,
  setAccessToken: (token: string | null): void => {
    _accessToken = token;
  },
  getRefreshToken: (): string | null => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('refresh_token');
  },
  setRefreshToken: (token: string | null): void => {
    if (typeof window === 'undefined') return;
    if (token) {
      localStorage.setItem('refresh_token', token);
    } else {
      localStorage.removeItem('refresh_token');
    }
  },
  clear: (): void => {
    _accessToken = null;
    if (typeof window !== 'undefined') {
      localStorage.removeItem('refresh_token');
    }
  },
};
